import { scrollIntoView } from './Scrolljs';
import Flickity from './Flickity';
import 'flickity-fullscreen';
import 'flickity-fade';

export default class PhotoGallery {
  constructor(element) {
    this.element = element;

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildGallery) return;

    this.index = 0;

    // Build Gallery
    this.buildGallery();
  }

  buildGallery() {
    this.gallery = new Flickity(this.gallerySlides, {
      fade: true,
      lazyLoad: 2,
      pageDots: false,
      wrapAround: true,
      fullscreen: true,
      arrowShape: 'M24.5,51.6v-3.2l19.6-19.6l3.2,3.2L31.5,47.8h44.1v4.5H31.5L47.2,68l-3.2,3.2L24.5,51.6z',
      on: {
        ready: this.onReady.bind(this),
        change: this.onChange.bind(this),
      },
    });

    this.galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', this.clickHandler.bind(this));
      thumb.index = index;
    });
  }

  onReady() {
    this.updateThumbs();
    this.updateIndicator();
  }

  onChange(index) {
    this.index = index;
    this.updateThumbs();
    this.updateIndicator();
  }

  clickHandler(event) {
    this.index = event.currentTarget.index;
    this.updateGallery();
    this.updateIndicator();
  }

  updateGallery() {
    this.gallery.select(this.currentIndex);
  }

  updateThumbs() {
    this.galleryThumbs[0].parentNode.setAttribute('data-selected-image', this.currentIndex + 1);
    this.galleryThumbs.forEach((thumb) => thumb.classList.remove('is-selected'));
    this.galleryThumbs[this.currentIndex].classList.add('is-selected');
    const destination = this.galleryThumbs[this.currentIndex];
    scrollIntoView(destination, this.galleryThumbsList, {
      block: 'nearest',
      behavior: 'smooth',
    });
  }

  updateIndicator() {
    this.galleryIndicator.textContent = `${this.currentIndex + 1}/${this.slides.length}`;
    this.galleryIndicator.setAttribute('aria-label', `Image ${this.currentIndex + 1} of ${this.slides.length}`);
  }

  get shouldBuildGallery() {
    return this.slides.length > 1;
  }

  get gallerySlides() {
    return this.element.querySelector('.gallery__slides');
  }

  get galleryThumbsList() {
    return this.element.querySelector('.gallery__thumbs ol');
  }

  get galleryThumbs() {
    return this.galleryThumbsList.querySelectorAll('li');
  }

  get galleryIndicator() {
    return this.element.querySelector('.gallery__indicator');
  }

  get slides() {
    return this.gallerySlides.querySelectorAll('figure');
  }

  get index() {
    return this.currentIndex;
  }

  set index(index) {
    this.currentIndex = index;
  }
}
